import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  FormGroup,
  MenuItem,
  Card,
  CardContent,
  Grid,
  Tooltip,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';

import { setDisable } from '../../redux/disable';
import AutocompleteParameters from '../../components/AutocompleteParameters';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import GroupButton from '../../components/Buttons/ButtonGroup';
import { TooltipMain } from 'components/tooltips/tooltipsMain';
import { TooltipInfo } from 'components/tooltips/tooltipsInfo';
import styleGlobal from '../../Global.module.css';
import InfoIcon from '@mui/icons-material/Info';
import HelpIcon from '@mui/icons-material/Help';
import { labelField } from 'utils';
import { parameterTypes } from 'utils/consts';

function Form() {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const [parameters, setParameters] = useState([]);
  const [parametersWithType, setParametersWithType] = useState([]);
  const [initialParameters, setInitialParameters] = useState([]);
  const disable = useSelector((state) => state.disable.disable);
  const history = useHistory();
  let { id } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const error = Error();
  const success = Success();
  const parametersIsNull = useState(false);

  function newOptions(options) {
    formik.setFieldValue('parameters', options);
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      name: '',
      type: '',
      isActive: true,
      parameters: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().max(
        50,
        'Máximo de caracteres ultrapassado (50 caracteres).',
      ).required('Campo Obrigatório'),
      isActive: Yup.string().required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      if (values.parameters.length === 0) {
        parametersIsNull[1](true);
        return true;
      }
      values.parameters = values.parameters.map((p) => ({
        parameter_id: p.id,
      }));
      request(values);
    },
  });

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);
    const tempParameters = [];
    if (data.parameters !== undefined) { data.parameters.map((v) => tempParameters.push(v.parameter)); }
    formik.setValues({ ...data, parameters: tempParameters });
    setInitialParameters(
      tempParameters.map((v) => ({ parameter_id: v.id })),
    );
  }

  useEffect(() => {
    async function loadData() {
      try {
        setOpenProgress(true);
        const parameter_ = await api.get('/parameters');

        setParameters(parameter_.data);
      } catch (err) {

      }
      setOpenProgress(false);
    }
    loadData();
  }, []);

  useEffect(() => {
    setParametersWithType(
      parameters.filter((parameter) => parameter.type === formik.values.type),
    );
  }, [formik.values.type, parameters]);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      if (id) {
        const results = initialParameters.filter(
          ({ parameter_id: id1 }) => !formik.values.parameters.some(
            ({ parameter_id: id2 }) => id2 === id1,
          ),
        );

        results.forEach(async (value, i) => {
          await api.delete(`/forms/${id}/parameters/${value.parameter_id}`);
        });
        await api.put(`/forms/${id}`, { ...data });
      } else {
        await api.post('/forms', { ...data });
      }
      success();
      history.push('/forms');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
  }

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      {' '}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {/** Carregamento circular para o carregamento dos dados */}
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Formulário
              {' '}
              <HtmlTooltip
                title={(
                  <>
                    Nessa tela é possível criar e editar formulários com diversos parâmetros para facilitar o cadastro de medições.
                  </>
                )}
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <Grid container spacing={2}>
                <Grid item xs={6} sm={3}>
                  <FormGroup>
                    <TextField
                      inputProps={{ maxLength: 51 }}
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="name"
                      label={labelField('Nome')}
                      variant="outlined"
                      name="name"
                      type="text"
                      value={formik.values.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={!!(formik.touched.name && formik.errors.name)}
                      helperText={
                        formik.touched.name
                        && formik.errors.name
                        && formik.errors.name
                      }
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={2}>
                  <FormGroup>
                    <TextField
                      InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                      id="isActive"
                      select
                      label={<div>Status</div>}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      variant="outlined"
                      value={formik.values.isActive}
                      name="isActive"
                      // as="select"
                      error={
                        !!(formik.touched.isActive && formik.errors.isActive)
                      }
                      helperText={
                        formik.touched.isActive
                        && formik.errors.isActive
                        && formik.errors.isActive
                      }
                    >
                      <MenuItem key={1} value>
                        Ativo
                      </MenuItem>
                      <MenuItem key={2} value={false}>
                        Inativo
                      </MenuItem>
                    </TextField>
                  </FormGroup>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <FormGroup>
                    <FormGroup>
                      <TextField
                        InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                        id="type"
                        select
                        label={labelField('Tipo do Formulário', 'Tipo do Formulário')}
                        onChange={(e) => {
                          formik.setFieldValue('type', e.target.value);
                          formik.setFieldValue('parameters', []);
                        }}
                        onBlur={formik.handleBlur}
                        variant="outlined"
                        value={formik.values.type}
                        name="type"
                        // as="select"
                        error={!!(formik.touched.type && formik.errors.type)}
                        helperText={
                          formik.touched.type
                          && formik.errors.type
                          && formik.errors.type
                        }
                      >
                        <MenuItem key={1} value={parameterTypes.SAUDE}>
                          Análise de Sáude
                        </MenuItem>
                        <MenuItem key={2} value={parameterTypes.ANIMAL}>
                          Biometria
                        </MenuItem>
                        <MenuItem key={3} value={parameterTypes.AGUA}>
                          Qualidade da Água
                        </MenuItem>
                      </TextField>
                    </FormGroup>
                  </FormGroup>
                </Grid>
                {/**
                 * Componente que lida com os parâmetros
                 */}
                {formik.values.parameters.length >= 0 && (
                  <AutocompleteParameters
                    type={formik.values.type}
                    disabled={formik.values.type === ''}
                    form_id={id}
                    parameters={formik.values.parameters}
                    options={parametersWithType}
                    callback={newOptions}
                    parametersIsNull={parametersIsNull}
                  />
                )}
              </Grid>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/forms/"
            routeDelete="/forms"
            returnRoute="/forms"
            id={id}
            disable={disable}
            message="A exclusão desse protolo pode levar a exclusão de objetos que dependam dele. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default Form;
